export default "__VITE_ASSET__DBjaD3tY__"